"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerUnmoderatedEventMailState = void 0;
var ProducerUnmoderatedEventMailState;
(function (ProducerUnmoderatedEventMailState) {
    ProducerUnmoderatedEventMailState["None"] = "None";
    ProducerUnmoderatedEventMailState["FirstReminder"] = "FirstReminder";
    ProducerUnmoderatedEventMailState["SecondReminder"] = "SecondReminder";
})(ProducerUnmoderatedEventMailState = exports.ProducerUnmoderatedEventMailState || (exports.ProducerUnmoderatedEventMailState = {}));
//# sourceMappingURL=producer-unmoderated-event-mail-state.js.map